"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Promotion = void 0;

var Promotion =
/** @class */
function () {
  function Promotion(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - eventId
   * @param string[]? - withData StackAndTicketType
   * @param string? - sortBy createdAt
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  Promotion.prototype.ListPromotionsForEvent = function (eventId, withData, sortBy, sortDirection, page, itemsPerPage) {
    if (withData === void 0) {
      withData = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('Promotion/UseCase/ListPromotionsForEvent', {
      eventId: eventId,
      withData: withData,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - eventId
   * @param string - promoCode
   * @param string[]? - withData PromotionStack
   * @return Promise|Observable|any
   */


  Promotion.prototype.ValidatePromotion = function (eventId, promoCode, withData) {
    if (withData === void 0) {
      withData = null;
    }

    return this.restClient.get('Promotion/UseCase/ValidatePromotion', {
      eventId: eventId,
      promoCode: promoCode,
      withData: withData
    });
  }; // Commands

  /**
   * @param string - eventId
   * @param string - promotionType
   * @param string - code
   * @param string - startTime
   * @param string - endTime
   * @param number - amount
   * @param number - used
   * @param string - message
   * @param number? - maximum
   * @param boolean? - isEnabled true|false
   * @param string? - promotionId
   * @param boolean? - isDeleted true|false
   * @return Promise|Observable|any
   */


  Promotion.prototype.CreatePromotion = function (eventId, promotionType, code, startTime, endTime, amount, used, message, maximum, isEnabled, promotionId, isDeleted) {
    if (maximum === void 0) {
      maximum = null;
    }

    if (isEnabled === void 0) {
      isEnabled = null;
    }

    if (promotionId === void 0) {
      promotionId = null;
    }

    if (isDeleted === void 0) {
      isDeleted = null;
    }

    return this.restClient.post('Promotion/UseCase/CreatePromotion', {
      eventId: eventId,
      promotionType: promotionType,
      code: code,
      startTime: startTime,
      endTime: endTime,
      amount: amount,
      used: used,
      message: message,
      maximum: maximum,
      isEnabled: isEnabled,
      promotionId: promotionId,
      isDeleted: isDeleted
    });
  };
  /**
   * @param string - promotionId
   * @return Promise|Observable|any
   */


  Promotion.prototype.DisablePromotion = function (promotionId) {
    return this.restClient.post('Promotion/UseCase/DisablePromotion', {
      promotionId: promotionId
    });
  };
  /**
   * @param string - promotionId
   * @return Promise|Observable|any
   */


  Promotion.prototype.EnablePromotion = function (promotionId) {
    return this.restClient.post('Promotion/UseCase/EnablePromotion', {
      promotionId: promotionId
    });
  };
  /**
   * @param string - promotionId
   * @return Promise|Observable|any
   */


  Promotion.prototype.RemovePromotion = function (promotionId) {
    return this.restClient.post('Promotion/UseCase/RemovePromotion', {
      promotionId: promotionId
    });
  };
  /**
   * @param string - promotionId
   * @param number - amount
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetAmount = function (promotionId, amount) {
    return this.restClient.post('Promotion/UseCase/SetAmount', {
      promotionId: promotionId,
      amount: amount
    });
  };
  /**
   * @param string - promotionId
   * @param string - code
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetCode = function (promotionId, code) {
    return this.restClient.post('Promotion/UseCase/SetCode', {
      promotionId: promotionId,
      code: code
    });
  };
  /**
   * @param string - promotionId
   * @param number - endTime
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetEndTime = function (promotionId, endTime) {
    return this.restClient.post('Promotion/UseCase/SetEndTime', {
      promotionId: promotionId,
      endTime: endTime
    });
  };
  /**
   * @param string - promotionId
   * @param number - maximum
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetMaximum = function (promotionId, maximum) {
    return this.restClient.post('Promotion/UseCase/SetMaximum', {
      promotionId: promotionId,
      maximum: maximum
    });
  };
  /**
   * @param string - promotionId
   * @param string - message
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetMessage = function (promotionId, message) {
    return this.restClient.post('Promotion/UseCase/SetMessage', {
      promotionId: promotionId,
      message: message
    });
  };
  /**
   * @param string - promotionId
   * @param string - promotionType
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetPromotionType = function (promotionId, promotionType) {
    return this.restClient.post('Promotion/UseCase/SetPromotionType', {
      promotionId: promotionId,
      promotionType: promotionType
    });
  };
  /**
   * @param string - promotionId
   * @param any[] - stackIds
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetStacksForPromotion = function (promotionId, stackIds) {
    return this.restClient.post('Promotion/UseCase/SetStacksForPromotion', {
      promotionId: promotionId,
      stackIds: stackIds
    });
  };
  /**
   * @param string - promotionId
   * @param number - startTime
   * @return Promise|Observable|any
   */


  Promotion.prototype.SetStartTime = function (promotionId, startTime) {
    return this.restClient.post('Promotion/UseCase/SetStartTime', {
      promotionId: promotionId,
      startTime: startTime
    });
  };
  /**
   * @param string - promotionId
   * @param string? - promotionType
   * @param string? - code
   * @param string? - startTime
   * @param string? - endTime
   * @param number? - amount
   * @param number? - used
   * @param string? - message
   * @param number? - maximum
   * @param boolean? - isEnabled true|false
   * @return Promise|Observable|any
   */


  Promotion.prototype.UpdatePromotion = function (promotionId, promotionType, code, startTime, endTime, amount, used, message, maximum, isEnabled) {
    if (promotionType === void 0) {
      promotionType = null;
    }

    if (code === void 0) {
      code = null;
    }

    if (startTime === void 0) {
      startTime = null;
    }

    if (endTime === void 0) {
      endTime = null;
    }

    if (amount === void 0) {
      amount = null;
    }

    if (used === void 0) {
      used = null;
    }

    if (message === void 0) {
      message = null;
    }

    if (maximum === void 0) {
      maximum = null;
    }

    if (isEnabled === void 0) {
      isEnabled = null;
    }

    return this.restClient.post('Promotion/UseCase/UpdatePromotion', {
      promotionId: promotionId,
      promotionType: promotionType,
      code: code,
      startTime: startTime,
      endTime: endTime,
      amount: amount,
      used: used,
      message: message,
      maximum: maximum,
      isEnabled: isEnabled
    });
  };

  return Promotion;
}();

exports.Promotion = Promotion;